// What? A React component for displaying source document content in test results.
// Why? To allow users to review the source documents used in prompt generation.
// How? Accordion-based expandable component showing document filename and content.

import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/joy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface SourceDocumentProps {
  fileName: string;
  content: string;
}

const SourceDocument: React.FC<SourceDocumentProps> = ({
  fileName,
  content,
}) => {
  return (
    <Accordion
      sx={{
        "&:hover": {
          boxShadow: "xs",
        },
      }}
    >
      <AccordionSummary indicator={<ExpandMoreIcon />}>
        <Typography
          level="body-sm"
          sx={{
            fontFamily: "code",
            color: "text.primary",
          }}
        >
          {fileName}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Box
          component="pre"
          sx={{
            mt: 2, // Add top margin to the content instead of padding on AccordionDetails
            p: 2,
            bgcolor: "background.level1",
            borderRadius: "sm",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontFamily: "code",
            fontSize: "xs",
            lineHeight: 1.5,
            overflow: "auto",
            maxHeight: "300px",
          }}
        >
          {content}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default SourceDocument;
